module.exports = __webpack_public_path__ + "img/samsung-n7000-galaxy-note-16gb.eec279f5.png";